import { EditorV2Page } from "./EditorV2Page";
export default EditorV2Page;
export * from "./EditorV2Page";
